import est from '../../../assets/img/marker/marker_77b83a@2x.png';
import est_offline from '../../../assets/img/marker/marker_77b83a@2x.png';
import egg from '../../../assets/img/marker/marker_egg@2x.png';
import egg_offline from '../../../assets/img/marker/marker_egg@2x.png';
import egg_taxi from '../../../assets/img/marker/marker_taxi@2x.png';
import others from '../../../assets/img/marker/marker_E59400@2x.png';
import others_offline from '../../../assets/img/marker/marker_E59400@2x.png';
import beoe from '../../../assets/img/marker/marker_4d79ff@2x.png';
import roaming from '../../../assets/img/marker/marker_ffe400@2x.png';
import connectortype4 from '../../../assets/img/marker/marker_77b83a@2x.png';
import connectortype5 from '../../../assets/img/marker/marker_77b83a@2x.png';
import unavailable from '../../../assets/img/marker/marker_grey@2x.png';
import faulted from '../../../assets/img/marker/marker_red@2x.png';


const markerImgs = {
    "est": est,
    "est_offline": est_offline,
    "egg": egg,
    "egg_offline": egg_offline,
    "egg-taxi": egg_taxi,
    "others": others,
    "others_offline": others_offline,
    "beoe": beoe,
    "roaming": roaming,
    "connector-type4": connectortype4,
    "connector-type5": connectortype5,
    "unavailable": unavailable,
    "faulted": faulted
  }
  
  export { markerImgs };